import { type ReactNode } from 'react'
import { cn } from '../../../lib/cn.ts'

interface SidebarLogoProps {
  isCollapsed: boolean
  onToggle: () => void
  children?: ReactNode
}

export function SidebarLogo({ isCollapsed, onToggle, children }: SidebarLogoProps) {
  return (
    <div
      className={cn(
        'group relative flex h-[72px] items-center px-5',
        isCollapsed ? 'justify-center' : 'justify-between',
      )}
    >
      <div className={cn('min-w-0 flex-1', isCollapsed && 'hidden')}>{children}</div>

      <button
        type="button"
        onClick={onToggle}
        className={cn(
          'flex h-7 w-7 shrink-0 items-center justify-center rounded-full',
          'border border-border bg-background-secondary text-sidebar-text',
          'transition-opacity duration-200',
          'hover:text-sidebar-active-text',
          isCollapsed ? 'opacity-100' : 'opacity-0 group-hover:opacity-100',
        )}
        aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={cn('transition-transform duration-300', isCollapsed && 'rotate-180')}
          aria-hidden="true"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
      </button>
    </div>
  )
}
